import { t } from '@deltasierra/shared';
import * as React from 'react';
import { Input } from '../../Input';
import { SelectedItemsList } from './SelectedItemsList';
import { AssetShareTarget, AssetShareTargetGroup } from './types';
import { AssetCheckboxClientGroup } from './AssetCheckboxClientGroup';

export type AssetLocationShareListProps = {
    clients: ReadonlyArray<AssetShareTargetGroup>;
    selected: ReadonlyArray<string>;
    disabled?: ReadonlyArray<string>;
    onChange: (selected: string[]) => void;
};

export const AssetLocationShareList: React.FC<AssetLocationShareListProps> = ({
    clients,
    disabled = [],
    onChange,
    selected,
}) => {
    const [searchTerm, setSearchTerm] = React.useState('');

    const selectedLocations = React.useMemo(
        () =>
            clients
                .reduce<AssetShareTarget[]>((carry, current) => [...carry, ...current.items], [])
                .filter(item => selected.includes(item.id)),
        [clients, selected],
    );

    const filteredItems = React.useMemo(
        () =>
            clients
                .reduce<AssetShareTargetGroup[]>((carry, current) => {
                    if (current.title.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())) {
                        return [...carry, current];
                    } else {
                        const filtered = current.items.filter(item =>
                            item.title.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()),
                        );
                        return [
                            ...carry,
                            {
                                ...current,
                                items: filtered,
                            },
                        ];
                    }
                }, [])
                .filter(client => client.items.length > 0),
        [clients, searchTerm],
    );

    return (
        <div className="col-sm-10">
            <div style={{ float: 'left' }}>
                <div
                    className="well"
                    style={{
                        background: 'white',
                        height: 200,
                        overflowX: 'hidden',
                        overflowY: 'auto',
                        scrollbarWidth: 'none',
                        width: 200,
                    }}
                >
                    <Input
                        clearable
                        placeholder={`${t('COMMON.FILTER')}...`}
                        style={{ width: '100%' }}
                        onTermChange={setSearchTerm}
                    />
                    {filteredItems.map(client => (
                        <AssetCheckboxClientGroup
                            client={client}
                            disabled={disabled}
                            key={client.id}
                            selected={selected}
                            onChange={onChange}
                        />
                    ))}
                </div>
            </div>
            <SelectedItemsList items={selectedLocations} title={t('COMMON.LOCATIONS')} />
        </div>
    );
};
AssetLocationShareList.displayName = 'AssetLocationShareList';
